import React, { Component } from 'react';

import Uuid from '../../../../../support/Uuid';
import ComercioExteriorDestinatarioDomicilioForm from './ComercioExteriorDestinatarioDomicilioForm';
import ComercioExteriorDestinatarioDomicilioList from './ComercioExteriorDestinatarioDomicilioList';

class ComercioExteriorDestinatarioDomicilioManager extends Component {
  state = {}

  handleOnAdd = (data) => {
    let domicilio = data.Domicilio;

    const { Domicilio = [] } = this.props.data;

    const newData = Domicilio.concat([{
      id: Uuid.v4(),
      ...domicilio
    }]);

    this.handleOnListChange(newData);
  }

  handleOnListChange = (data) => {
    const newData = {
      Domicilio: data
    }

    this.props.onChange(newData);
  }

  handleOnEdit = (item) => {
    this.setState({
      data: {
        Domicilio: { ...item }
      }
    }, () => {
      this.setState({
        data: undefined
      });
    });
  }

  render() {
    const { data } = this.state;
    const { Domicilio = [] } = this.props.data;

    return (
      <>
        <fieldset>
          <legend>Domicilio</legend>

          <ComercioExteriorDestinatarioDomicilioForm
            data={ data }
            onAdd={ this.handleOnAdd }
          />

          <ComercioExteriorDestinatarioDomicilioList
            data={ Domicilio }
            onEdit={ this.handleOnEdit }
            onChange={ this.handleOnListChange }
          />
        </fieldset>
      </>
    )
  }
}

export default ComercioExteriorDestinatarioDomicilioManager;